import { useEffect, useRef } from 'react';

export default function ContactSection() {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('opacity-100', 'translate-y-0');
          e.target.classList.remove('opacity-0', 'translate-y-6');
        }
      }),
      { threshold: 0.1 }
    );
    ref.current?.querySelectorAll('.anim').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="contact" ref={ref} className="w-full py-16 md:py-24 bg-[#f0f7ff]">
      <div className="max-w-6xl mx-auto px-4 md:px-8">

        {/* Top CTA banner */}
        <div className="anim opacity-0 translate-y-6 transition-all duration-500 relative overflow-hidden bg-primary rounded-3xl p-8 md:p-12 mb-10 text-center">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-1/4 w-64 h-64 bg-white rounded-full -translate-y-1/2" />
            <div className="absolute bottom-0 right-1/4 w-48 h-48 bg-white rounded-full translate-y-1/2" />
          </div>
          <div className="relative z-10">
            <p className="text-white/70 text-sm font-medium mb-2 uppercase tracking-widest">İletişim ve Servis Talebi</p>
            <h2 className="text-2xl md:text-4xl font-extrabold text-white mb-3 tracking-tight">
              Kombi arızanız mı var?
            </h2>
            <p className="text-white/75 text-sm md:text-base mb-8 max-w-md mx-auto">
              Hemen arayın, uzman ekibimiz en kısa sürede kapınızda olsun.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href="tel:05332836679"
                className="inline-flex items-center justify-center gap-2 bg-white text-primary font-bold text-base px-8 py-4 rounded-full hover:bg-slate-50 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-fill text-lg" />
                0533 283 66 79
              </a>
              <a
                href="https://wa.me/905332836679"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-green-500 hover:bg-green-400 text-white font-bold text-base px-8 py-4 rounded-full transition-colors whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-lg" />
                WhatsApp'tan Yaz
              </a>
            </div>
          </div>
        </div>

        {/* Info cards */}
        <div className="anim opacity-0 translate-y-6 transition-all duration-500 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <a
            href="tel:05332836679"
            className="group flex items-center gap-4 bg-white rounded-2xl border border-[#dbeafe] p-5 hover:border-primary/30 hover:shadow-md transition-all"
          >
            <div className="w-12 h-12 flex items-center justify-center bg-primary/[0.06] text-primary rounded-xl flex-shrink-0 group-hover:bg-primary group-hover:text-white transition-all">
              <i className="ri-phone-fill text-xl" />
            </div>
            <div>
              <p className="text-xs text-slate-400 font-medium mb-0.5">Telefon</p>
              <p className="text-sm font-bold text-slate-900 group-hover:text-primary transition-colors">0 (533) 283 66 79</p>
            </div>
          </a>

          <a
            href="https://wa.me/905332836679"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-4 bg-white rounded-2xl border border-[#dbeafe] p-5 hover:border-green-300 hover:shadow-md transition-all"
          >
            <div className="w-12 h-12 flex items-center justify-center bg-green-50 text-green-600 rounded-xl flex-shrink-0 group-hover:bg-green-500 group-hover:text-white transition-all">
              <i className="ri-whatsapp-line text-xl" />
            </div>
            <div>
              <p className="text-xs text-slate-400 font-medium mb-0.5">WhatsApp</p>
              <p className="text-sm font-bold text-slate-900 group-hover:text-green-600 transition-colors">Hızlı destek alın</p>
            </div>
          </a>

          <div className="flex items-center gap-4 bg-white rounded-2xl border border-[#dbeafe] p-5">
            <div className="w-12 h-12 flex items-center justify-center bg-primary/[0.06] text-primary rounded-xl flex-shrink-0">
              <i className="ri-time-line text-xl" />
            </div>
            <div>
              <p className="text-xs text-slate-400 font-medium mb-0.5">Çalışma Saatleri</p>
              <p className="text-sm font-bold text-slate-900">Hft içi 08–20 | Cmt 09–18</p>
              <p className="text-xs text-primary font-semibold mt-0.5">7/24 Acil Servis</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}